// UI Layout Constants
export const SIDEBAR_WIDTH = 345;
export const SIDEBAR_TOP_OFFSET = 52;
export const SIDEBAR_NAV_WIDTH = 80;
export const FOOTER_HEIGHT = 74;
export const INTER_PANEL_BORDER = 4;

// UI Component Constants
export const TILE_HEIGHT = 300;
export const TILE_WIDTH = 294;
export const RATIO_BOX_SIZE = 262;
// SrTile.Info's minimum height, exported for skeletons that mirror its layout.
export const TILE_INFO_MIN_HEIGHT = 50;

// `SrTileGrid`'s minimum column width per breakpoint.
export const TILE_GRID_MIN_COLUMN_WIDTH = {
  xs: 240,
  sm: 288,
} as const;
